import { render } from "./ConfirmSummaryGenerationModal.vue?vue&type=template&id=5384c4ac&scoped=true"
import script from "./ConfirmSummaryGenerationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmSummaryGenerationModal.vue?vue&type=script&lang=js"

import "./ConfirmSummaryGenerationModal.vue?vue&type=style&index=0&id=5384c4ac&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5384c4ac"]])

export default __exports__